<div id="heroCarousel" class="hero-carousel position-relative overflow-hidden">
  <!-- Carousel Bootstrap -->
  <div id="carousel" class="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-interval="5000">
    <div class="carousel-inner">
      <div class="carousel-item active">
        <div class="hero-image" style="background-image: url('/images/caroussel/caroussel.png');"></div>
      </div>
      <div class="carousel-item">
        <div class="hero-image" style="background-image: url('/images/caroussel/caroussel\ electricien.png');"></div>
      </div>
      <div class="carousel-item">
        <div class="hero-image" style="background-image: url('/images/caroussel/caroussel\ nettoyage.png');"></div>
      </div>
      <div class="carousel-item">
        <div class="hero-image" style="background-image: url('/images/caroussel/caroussel\ informatique.png');"></div>
      </div>
    </div>

    <!-- Flèches de navigation -->
    <button class="carousel-control-prev" type="button" data-bs-target="#carousel" data-bs-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Précédent</span>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#carousel" data-bs-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Suivant</span>
    </button>
  </div>

  <!-- Overlay avec gradient -->
  <div class="hero-overlay"></div>

  <!-- Contenu principal -->
  <div class="hero-content">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-10 col-xl-9 text-center">
          <!-- Badge animé -->
          <div class="hero-badge mb-4">
            <span class="badge-text">Nouvelle génération</span>
          </div>

          <!-- Titre principal -->
          <h1 class="hero-title mb-4">
            L'annuaire qui rend les professionnels 
            <span class="text-gradient">visibles en un clic</span>
          </h1>

          <!-- Sous-titre -->
          <p class="hero-subtitle mb-5">
            Le moyen le plus simple pour trouver le bon professionnel… ou pour être trouvé.
          </p>

          <!-- Boutons CTA -->
          <div class="hero-cta d-flex flex-column flex-sm-row gap-3 justify-content-center align-items-center">
            <a href="#filters" class="btn btn-primary btn-lg px-5 py-3 d-flex align-items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.35-4.35"></path>
              </svg>
              Trouver un professionnel
            </a>
            <a routerLink="signup" class="btn btn-outline-light btn-lg px-5 py-3 d-flex align-items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <line x1="19" y1="8" x2="19" y2="14"></line>
                <line x1="22" y1="11" x2="16" y2="11"></line>
              </svg>
              Référencer mon activité
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Indicateurs personnalisés -->
  <div class="hero-indicators">
    <button type="button" data-bs-target="#carousel" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
    <button type="button" data-bs-target="#carousel" data-bs-slide-to="3" aria-label="Slide 4"></button>
  </div>
</div>